import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { Grid, Link, Typography } from '@material-ui/core';

// Icons (see https://material-ui.com/components/material-icons/)
import {
  AccountCircle as AccountCircleIcon,
  Lock as LockIcon,
} from '@material-ui/icons';

import { yupResolver } from '@hookform/resolvers';

import { useForm } from 'react-hook-form';

import Logo from '../../components/logo/logo';
import { schemaLogin } from '../../_schema';
import { AmFormButton, AMTextField } from '../../controls';
import { appStyles } from '../../_styles';
import { AppContext } from '../../_context';

const SignIn = () => {
  const classes = appStyles();

  const { control, handleSubmit, errors } = useForm({
    resolver: yupResolver(schemaLogin),
  });

  return (
    <div>
      <Logo></Logo>
      <Typography variant="body1" component="h1" color="textSecondary">
        Early alpha release.
      </Typography>
      <AppContext.Consumer>
        {({ loginUser }) => (
          <form className={classes.form} onSubmit={handleSubmit(loginUser)}>
            <AMTextField
              name="userNameOrEmail"
              control={control}
              errors={errors}
              schema={schemaLogin}
              icon={AccountCircleIcon}
            />

            <AMTextField
              name="password"
              control={control}
              errors={errors}
              schema={schemaLogin}
              icon={LockIcon}
              type="password"
            />

            <Grid container direction="row" justify="flex-end">
              <Grid item>
                <Link
                  component={RouterLink}
                  to="/forgot-password"
                  variant="body2"
                >
                  Forgot password?
                </Link>
              </Grid>
            </Grid>

            <AmFormButton>Sign In</AmFormButton>

            <Grid container direction="row" justify="center">
              <Grid item>
                <Link component={RouterLink} to="/sign-up" variant="body2">
                  {"Don't have an account? Sign Up"}
                </Link>
              </Grid>
            </Grid>
          </form>
        )}
      </AppContext.Consumer>
    </div>
  );
};

export { SignIn };
